import React, { useCallback, useEffect, useRef, useState } from 'react';
import ErrorContainer from '../../components/utils/ErrorContainer';
import { useSelector } from 'react-redux';
import { fromStore, userRoleSelector } from '../../selectors';
import { useDispatch } from 'react-redux';
import {
    fetchCategories,
    fetchGoods,
    fetchRawsList,
    fetchRegionPrices,
    setActiveModalAction,
    updateGoodsPrices,
    updateRegionPrice,
} from '../../action';
import { CategoryList, GoodsList } from '../../containers';
import { utils, writeFileXLSX, read } from 'xlsx';
import { roleId, xmlBackenHost } from '../../constants/app';
import { getNewPrice, roundToFixed } from '../../utils/common';
import { setUIvisible } from '../../action/UImobile';
import HeadMobileActionMenu from '../../components/utils/HeadMobileActionMenu';
import ButtonActionMenu from '../../components/utils/ButtonActionMenu';
import { editPriceGoodsKuper, importCategoriesKuper, importGoodsKuper, importModsGoodsKuper } from '../../action/kuper';
import swal from 'sweetalert';
import { groupBy, isEmpty, isEqual } from 'lodash';
import { importReceipes, receipesCount } from '../../action/recipes';
import moment from 'moment';
import { GroupsList } from '../../containers/goods/list/GroupsList';
import ExcelJS from 'exceljs';

export const ingredientsVariable = [
    { value: 'raw', variables: ['СЫРЬЕ', 'СЫР', 'СЫР.', ] },
    { value: 'semi', variables: ['ПОЛУФАБРИКАТ', 'ПОЛУФАБРИКАТЫ', 'П/Ф'] },
    { value: 'good', variables: ['ТОВАР', 'ТОВАРЫ'] }
]

function ListGoodPage() {
    const refImport = useRef();
    const refImportReceipes = useRef();
    const refImprotRegionPrices = useRef();
    const dispatch = useDispatch();
    const count = useSelector(fromStore.countGoodsSelector);
    const countGroups = useSelector(fromStore.countGroupsSelector);
    const goods = useSelector(state => state.good.list);

    const selectedCategoryGoods = useSelector(fromStore.selectedCategoryGoods);
    const goodListSelector = useSelector(fromStore.goodListSelector);
    const activeCategory = useSelector(fromStore.activeCategorySelector);
    const role = useSelector(userRoleSelector);
    const raws = useSelector(fromStore.rawListSelector);

    const [type, setType] = useState('goods');

    useEffect(() => {
        isEmpty(goods) && dispatch(fetchGoods());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch])

    const actionsMobile = [
        { name: 'Добавить товар', icon: 'flaticon2-plus', action: () => onOpenModalGood() },
        { name: 'Добавить группу товаров', icon: 'flaticon2-plus', action: () => onOpenModalGroup() },
        { name: 'Добавить категорию', icon: 'flaticon2-plus', action: () => onOpenModalCategory() },
        { name: 'Редактировать категорию', icon: 'la la-edit', action: () => onOpenModalCategory(activeCategory) },
        { name: 'Экспорт категории', icon: 'flaticon2-download', action: () => onExport(selectedCategoryGoods) },
        { name: 'Экспорт все', icon: 'flaticon2-download', action: () => onExport(goodListSelector) },
    ];

    const actionsKuper = [
        { name: 'Импорт товаров', action: () => dispatch(importGoodsKuper())},
        { name: 'Импорт модификаций', action: () => dispatch(importModsGoodsKuper())},
        { name: 'Импорт категорий', action: () => dispatch(importCategoriesKuper())},
        { name: 'Импорт цен товаров', action: () => dispatch(editPriceGoodsKuper())},
    ];

    const importRegionPrices = useCallback(async (e) => {
        if (!e.target.files[0]) return;

        const file = e.target.files[0];
        if (!file.arrayBuffer) return;

        const getCondition = (condition) => {
            switch (condition) {
                case '+': return 'plus';
                case '-': return 'minus';
                case '*': return 'multiply';
                default: return 'equal';
            }
        }

        try {
            dispatch({ type: 'SET_LOADER', field: 'blockedPhonesImport', value: true });

            const data = await file.arrayBuffer();
            if (!data) throw new Error('Не удалось прочитать файл');

            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(data);

            const worksheet = workbook.getWorksheet(1);
            if (!worksheet) throw new Error('В файле нет листов');

            const importData = [];
            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber === 1) {
                    const cellNameId = row.getCell(1);
                    const cellNameValue = row.getCell(3);
                    if (cellNameId.value !== 'id' || cellNameValue.value !== 'Товар') throw new Error('Неверный шаблон файла, скачайте актуальный шаблон нажав на кнопку "Экспорт формы".');
                }

                const idCell = row.getCell(1);
                const id = idCell.value !== undefined ? +idCell.value : undefined;

                const conditionCell = row.getCell(4);
                const persentCell = row.getCell(5);
                const priceCell = row.getCell(6);
                const oldPriceCell = row.getCell(7);
                const activeCell = row.getCell(8);

                let price = priceCell.value !== undefined ? roundToFixed(priceCell.value) : undefined;
                if (isNaN(price)) price = 0;

                let oldPrice = oldPriceCell.value !== undefined ? roundToFixed(oldPriceCell.value) : undefined;
                if (isNaN(oldPrice)) oldPrice = 0;

                const active = activeCell.value === 'Включена' ? true : false;
                const persent = persentCell.value === 'true' ? true : false;
                const condition = getCondition(conditionCell.value);

                if (id !== undefined && !isNaN(id)) importData.push({ id, price, oldPrice: oldPrice || null, active, persent, condition });
            });

            if (!importData || importData.length === 0) throw new Error('Файл не содержит данных');

            const regionprices = await dispatch(fetchRegionPrices(true));

            const filteredImportData = importData.filter((impData) => {
                const entity = regionprices.find((regionprice) => regionprice.id === impData.id);
                if (!entity) return false;

                const entityData = {
                    id: entity.id,
                    price: entity.price,
                    oldPrice: entity.oldPrice,
                    active: entity.active,
                    persent: entity.persent,
                    condition: entity.condition,
                };

                return !isEqual(entityData, impData);
            });

            if (!filteredImportData || filteredImportData.length === 0) throw new Error('Файл не содержит новых данных');

            return swal({
                title: "Вы импортируете данные региональные цены",
                text: "Данные о рег. ценах будут заменены на данные из файла",
                icon: "warning",
                buttons: ["Отмена", "Подтвердить"],
            }).then(async (willImport) => {
                if (willImport) {
                    let errors = 0;
                    await Promise.all(filteredImportData.map(async (impData) => {
                        const result = await dispatch(updateRegionPrice(impData.id, { ...impData, isImport: true }));
                        if (!result) errors += 1;
                    }));
                    if (!errors) onRefresh();
                }
            });
        } catch (error) {
            console.error('Ошибка при импорте данных:', error);
            return swal({
                title: 'Ошибка',
                text: `Ошибка при импорте данных: ${error.message || 'Неизвестная ошибка'}`,
                icon: 'error',
                dangerMode: true
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const exportFromRegionPrices = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Форма рег цен');
    
        worksheet.addRow(['id', 'Город(а)', 'Товар', 'Условие', 'Проценты', 'Цена', 'Старая цена', 'Активность']);
        const exportData = [];

        const regionprices = await dispatch(fetchRegionPrices(true));

        const getCities = (regionprice) => {
            if (!regionprice || isEmpty(regionprice.cities)) return '';
            const names = [];
            regionprice.cities.forEach((city) => {
                if (city && city.name) names.push(city.name);
            });

            return names.length > 0 ? names.join(', ') : '';
        }

        const getGood = (regionprice) => {
            if (!regionprice) return;

            if (regionprice.goodId) {
                const entity = goods.find((good) => good.id === regionprice.goodId);
                if (entity) return entity.name;
            }

            const entity = goods.find((good) => (good.regionprices || []).some((reg) => reg.id === regionprice.id));
            if (entity) return entity.name;
            return '';
        }

        const getConditionForCell = (condition) => {
            switch (condition) {
                case 'plus': return '+';
                case 'minus': return '-';
                case 'multiply': return '*';
                default: return '=';
            }
        }

        regionprices.forEach((regionprice) => {
            const cities = getCities(regionprice);
            const good = getGood(regionprice);
            exportData.push({ id: regionprice.id, cities, good, condition: getConditionForCell(regionprice.condition), persent: !!regionprice.persent ? 'true' : 'false', price: regionprice.price, oldPrice: regionprice.oldPrice, active: !!regionprice.active ? 'Включена' : 'Выключена' });
        })
    
        if (!exportData || exportData.length === 0) return;
    
        exportData.forEach((item) => {
            worksheet.addRow([item.id, item.cities, item.good, item.condition, item.persent, item.price, item.oldPrice, item.active]);
        });
    
        worksheet.views = [
            { state: 'frozen', ySplit: 1 }
        ];

        const generateRandomPassword = () => {
            return String(Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));
        };

        const calculateRowHeight = (row, columnWidths) => {
            let maxLines = 1;

            row.eachCell((cell, colNumber) => {
                if (cell.value && typeof cell.value === 'string') {
                    const text = cell.value;
                    const colWidthInChars = columnWidths[colNumber - 1];
                    const textLength = text.length;
                    const lines = Math.ceil(textLength / colWidthInChars);
                    if (lines > maxLines) maxLines = lines;
                }
            });

            return Math.max(15, maxLines * 15);
        }
        
        const columnWidths = [ 10, 25, 25, 10, 10, 15, 15, 15 ];
        worksheet.getColumn(1).width = columnWidths[0];
        worksheet.getColumn(2).width = columnWidths[1];
        worksheet.getColumn(3).width = columnWidths[2];
        worksheet.getColumn(4).width = columnWidths[3];
        worksheet.getColumn(5).width = columnWidths[4];
        worksheet.getColumn(6).width = columnWidths[5];
        worksheet.getColumn(7).width = columnWidths[6];
        worksheet.getColumn(8).width = columnWidths[7];
    
        const headerRow = worksheet.getRow(1);
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFC9C9C9' }
            };
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
    
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.alignment = {
                    ...cell.alignment,
                    wrapText: true,
                    vertical: 'middle'
                };
            });
        });
    
        worksheet.eachRow((row, rowNumber) => {
            row.eachCell((cell) => {
                if (rowNumber === 1) {
                    cell.protection = { locked: true };
                    row.height = 15;
                } else {
                    cell.protection = { locked: ![4, 5, 6, 7, 8].includes(cell.col) };
                    if ([6, 7].includes(cell.col)) cell.dataValidation = {
                        type: 'decimal',
                        operator: 'greaterThanOrEqual',
                        formulae: [0],
                        allowBlank: true,
                        showErrorMessage: true,
                        errorTitle: 'Ошибка ввода',
                        error: 'Поддерживаются только числовые положительные значения'
                    };
                    const height = calculateRowHeight(row, columnWidths);
                    row.height = Math.min(Math.max(height, 20), 100);
                }

                if (rowNumber !== 1) {
                    const cell4 = row.getCell(4);
                    cell4.dataValidation = {
                        type: 'list',
                        formulae: ['"=,+,-,*"'],
                        allowBlank: false,
                        showErrorMessage: true,
                        errorTitle: 'Неверное значение',
                        error: 'Выберите значение из списка'
                    };
                
                    const cell5 = row.getCell(5);
                    cell5.dataValidation = {
                        type: 'list',
                        formulae: ['"true,false"'],
                        allowBlank: true,
                        showErrorMessage: true,
                        errorTitle: 'Неверное значение',
                        error: 'Выберите процент из списка'
                    };
                
                    const cell8 = row.getCell(8);
                    cell8.dataValidation = {
                        type: 'list',
                        formulae: ['"Включена,Выключена"'],
                        allowBlank: false,
                        showErrorMessage: true,
                        errorTitle: 'Неверное значение',
                        error: 'Выберите true или false'
                    };
                }
            });
        });
    
        const password = generateRandomPassword()
        await worksheet.protect(password, {
            selectLockedCells: true,
            selectUnlockedCells: true,
            sort: false,
            autoFilter: false,
        });
    
        worksheet.properties.outlineProperties = { summaryBelow: false };
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Форма для рег цен.xlsx`;
        link.click();
    };

    const handleImportClick = () => {
        if (refImprotRegionPrices.current) refImprotRegionPrices.current.click();
    };

    const actionsRegionprices = [
        { name: 'Экспорт формы', action: () => exportFromRegionPrices() },
        { name: 'Импорт', action: () => handleImportClick() }
    ];

    const onRefresh = () => {
        dispatch(fetchGoods());
        dispatch(fetchCategories());
    };

    useEffect(() => {
        dispatch(setUIvisible(false, true))
    }, [dispatch])

    const onOpenModalCategory = (id) => {
        const categoryId = id || 'new';
        dispatch(setActiveModalAction({ field: 'category', value: categoryId }));
    };

    const onOpenModalGood = (id) =>  {
        const goodId = id || 'new';
        dispatch(setActiveModalAction({ field: 'good', value: goodId }));
    }

    const onOpenModalGroup = () => {
        dispatch(setActiveModalAction({ field: 'groupgood', value: 'new' }));
    }

    const onExport = (items) => {
        const updateGoogs = items.reduce((prev = [], item) => {
            if(item.modifications.length > 0) {
                item.modifications.forEach(modification => {
                    const result = {
                        ...item, 
                        modifications: [{...modification}],
                        oldPrice: getNewPrice(item.oldPrice, modification.condition, modification.oldPrice, modification.persent, modification.active),
                        price: getNewPrice(item.price, modification.condition, modification.price, modification.persent, modification.active),
                        modificationId: modification.id,
                        modificationTitle: modification.title,
                    }
                    prev.push(result)
                });
            } else {
                prev.push(item)
            }

            return prev
        }, [])

        const filterGoods = updateGoogs.filter((item) => !item.isGroup).map(item => {
            return {
                'id': item.id,
                'Название': item.name,
                'id модификации': item.modificationId == null ? '-' : item.modificationId,
                'Модификация': item.modificationTitle == null ? '-' : item.modificationTitle,
                'Описание': item.description,
                'Цена': item.price,
                'Старая цена': item.oldPrice,
                'Ссылка на изображение товара': `${xmlBackenHost}${item.image== null ? '-' : item.image.url}`,
                'Id категории': item.category == null ? '-' : item.category.id,
                'Категория': item.category == null ? '-' : item.category.title,
            }
        })
        const ws = utils.json_to_sheet(filterGoods);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Data");
        writeFileXLSX(wb, "Товары2.0.xlsx");
    }

    const onImport = async (e) => {
        if (!e.target.files[0]) return;

        const file = e.target.files[0];

        if (!file.arrayBuffer) return;

        const data = await file.arrayBuffer();

        if (!data) return;

        if(data) {
            const wb = read(data);
            const ws = wb.Sheets[wb.SheetNames[0]];
            const pricesExcel = utils.sheet_to_json(ws);
            const result = pricesExcel.map(item => {
                const price = {
                    id: item.id,
                    modifications: item['Модификация'],
                    modificationsId: item['id модификации'],
                    price: item['Цена'],
                    oldPrice: item['Старая цена'],
                }
                return price;
            });
            const res = await dispatch(updateGoodsPrices({ updateData: result }));

            if (res) onRefresh();
        }
        if (refImport.current) refImport.current.value = "";
    }

    const onImportReceipes = async (e) => {
        if (!e.target.files[0]) {
            refImportReceipes.current.value = "";
            return swal({
                title: "Ошибка импорта",
                text: 'Файл не загружен',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        const file = e.target.files[0];

        if (!file.arrayBuffer) {
            refImportReceipes.current.value = "";
            return swal({
                title: "Ошибка импорта",
                text: 'Неверный формат данных',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        const data = await file.arrayBuffer();

        if (!data) {
            refImportReceipes.current.value = "";
            return swal({
                title: "Ошибка импорта",
                text: 'Данные не найдены',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }

        if(data) {
            const errors = [];

            const getType = (text, name) => {
                if (!text) {
                    errors.push(`Не указан тип для ингредиента ${name}`);
                    return null;
                }
                const result = ingredientsVariable.find((item) => item.variables.includes(text.toUpperCase()));
                if (result && result.value) return result.value;
                errors.push(`Тип ингредиента ${text} не найден`);
            }

            const getDate = (date) => {
                const parseDate = moment(date);
                const seconds = parseDate.seconds();
                if (seconds >= 30) return new Date(parseDate.add(1, 'minute').startOf('minute'));
                return new Date(parseDate.startOf('minute'));
            }

            let rawmaterials = raws;
            if (isEmpty(rawmaterials)) rawmaterials = await dispatch(fetchRawsList(true, true));
            let goods = goodListSelector.filter((item) => !item.isGroup);
            if (isEmpty(goods)) goods = await dispatch(fetchGoods(true, true));

            const wb = read(data, { cellDates: true });
            const ws = wb.Sheets[wb.SheetNames[0]];
            const dataExcel = utils.sheet_to_json(ws);

            const groupedById = groupBy(dataExcel, (item) => item.id || "id товара не указан");
            const groupedData = Object.entries(groupedById).reduce((acc, [id, items]) => {
                const groupedByDate = groupBy(items, (item) => item['Дата'] || "Дата не указана");
                acc[id] = groupedByDate;
                return acc;
            }, {});

            let importData = (await Promise.all(Object.entries(groupedData).map(async ([id, groupedDate]) => {
                return await Promise.all((Object.entries(groupedDate).map(async ([date, items]) => {
                    const productId = parseInt(id);

                    if (!goods.find((good) => good.id === productId)) {
                        errors.push(`Товар с id ${id} не найден. Рецепт не создан.`);
                        return null;
                    }
    
                    const count = await dispatch(receipesCount({productId: productId, type: 'good'}));
                    if (count >= 3) {
                        errors.push(`Превышение ограничения кол-ва рецептов для товара с id ${id}. Чтобы создать новый рецепт - удалите старый. Рецепт не был создан.`);
                        return null;
                    }
                    const startDate = getDate(new Date(date));
                    const type = 'good';

                    const ingredientsMap = new Map();

                    items.forEach((item) => {
                    const ingredientType = getType(item['Тип ингредиента']);
                    let arr = [];
                    if (ingredientType === 'good') {
                        arr = goods.flatMap((good) => {
                            if (!good.modifications || good.modifications.length === 0) return [good];
                            return [...good.modifications.map((mod) => ({
                                ...good,
                                id: mod.default ? good.id : `${good.id}_${mod.id}`,
                                name: `${good.name}${mod.title ? ` ${mod.title}` : ''}`
                            })), {...good, id: good.id, name: good.name }];
                        });
                    } else {
                        arr = rawmaterials;
                    }
                    const ingredientData = arr.find((raw) => raw.name.toUpperCase() === String(item['Название ингредиента']).toUpperCase());
                    if (!ingredientData) {
                        errors.push(`Ингредиент с названием ${item['Название ингредиента']} и типом ${item['Тип ингредиента']} не найден. Рецепт создан без него.`);
                        return null;
                    }
                    
                    const quantity = parseFloat(item['Кол-во ингредиента']) || 0;
                    const ingredientKey = `${ingredientData.id}_${ingredientType}`;
                    
                    if (ingredientsMap.has(ingredientKey)) {
                        const entity = ingredientsMap.get(ingredientKey);
                        
                        Object.entries({ default: quantity }).forEach(([key, value]) => {
                            if (entity.quantity[key]) {
                                entity.quantity[key] += value;
                            } else {
                                entity.quantity[key] = value;
                            }
                        });
                    } else {
                        ingredientsMap.set(ingredientKey, {
                            id: ingredientData.id,
                            type: ingredientType,
                            quantity: {
                                default: quantity
                            }
                        });
                    }
                });
                const ingredients = Array.from(ingredientsMap.values());
                    return {
                        startDate,
                        productId,
                        type,
                        ingredients,
                        originalId: id,
                    }
                })))
            }))).flat().filter((item) => item && item.ingredients && item.ingredients.length > 0);

            if (!importData || importData.length === 0) return swal({
                title: "Ошибка импорта. Не найдены ингредиенты.",
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            }).then(() => onRefresh());
            

            const mainItemsMap = new Map();
            const modsItems = [];
            
            importData.forEach((item) => {
                if (item.originalId && item.originalId.includes('_')) {
                    modsItems.push(item);
                } else {
                    const key = `${item.productId}_${item.startDate.toISOString()}`;
                    mainItemsMap.set(key, item);
                }
            });

            modsItems.forEach((modItem) => {
                if (!modItem.originalId.includes('_')) return;
                
                const [mainId, field] = modItem.originalId.split('_');
                const key = `${mainId}_${modItem.startDate.toISOString()}`;
                const mainItem = mainItemsMap.get(key);
                
                if (!mainItem) {
                    errors.push(`Основной элемент с id ${mainId} и датой ${modItem.startDate} не найден для дополнительного элемента ${modItem.originalId}`);
                    importData = importData.filter((item) => item.originalId !== modItem.originalId);
                    return;
                }
                
                modItem.ingredients.forEach(additionalIngredient => {
                    const existingIngredient = mainItem.ingredients.find(ing => 
                        ing.id === additionalIngredient.id && ing.type === additionalIngredient.type
                    );
                    
                    if (existingIngredient) {
                        if (existingIngredient.quantity[field]) {
                            existingIngredient.quantity[field] += additionalIngredient.quantity.default || 0;
                        } else {
                            existingIngredient.quantity[field] = additionalIngredient.quantity.default || 0;
                        }
                    } else {
                        mainItem.ingredients.push({
                            id: additionalIngredient.id,
                            type: additionalIngredient.type,
                            quantity: {
                                default: additionalIngredient.quantity.default || 0,
                                [field]: additionalIngredient.quantity.default || 0
                            }
                        });
                    }
                });
                
                const index = importData.indexOf(modItem);
                if (index > -1) importData.splice(index, 1);
            });

            if (importData && importData.length > 0) {
                const result = await dispatch(importReceipes(importData));
                if (result && errors.length === 0) {
                    refImportReceipes.current.value = "";
                    return swal({
                        title: "Импорт выполнен",
                        icon: "success",
                        button: "Ок",
                    });
                }

                if (!result || result.length === 0) {
                    refImportReceipes.current.value = "";
                    return swal({
                        title: "Неизвестная ошибка импорта",
                        icon: "warning",
                        dangerMode: true,
                        button: "Ок",
                    }).then(() => onRefresh());
                }

                if (result && result.length > 0 && errors.length > 0) {
                    const errorText = errors.join(' | ');
                    refImportReceipes.current.value = "";
                    return swal({
                        title: "Импорт выполнен с ошибками",
                        text: errorText,
                        icon: "warning",
                        dangerMode: true,
                        button: "Ок",
                    });
                }
            }
            const errorText = errors.join(' | ');
            return swal({
                title: "Импорт не выполнен",
                text: errorText,
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        }
        refImportReceipes.current.value = "";
    }

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Товары</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc" id="kt_subheader_total">
                            {count}
                        </span>
                    </div>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <h3 className="kt-subheader__title">Группы</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc" id="kt_subheader_total">
                            {countGroups}
                        </span>
                    </div>
                </div>
                <div className="kt-subheader__toolbar">
                    <ButtonActionMenu title='Рег. цены' actions={actionsRegionprices}/>
                    <input
                        type="file"
                        ref={refImprotRegionPrices}
                        onChange={importRegionPrices}
                        style={{ display: 'none' }}
                        accept=".xlsx,.xls"
                    />
                    {role === roleId.admin && <ButtonActionMenu title='Купер' actions={actionsKuper}/>}
                    {window.innerWidth > 1024 && 
                        <>
                            <button onClick={(() => onExport(selectedCategoryGoods))} className="btn btn-dark btn-icon-sm">Экспорт категории</button>
                            <button onClick={(() => onExport(goodListSelector))} className="btn btn-dark btn-icon-sm">Экспорт все</button>
                        </>
                    }
                    <label className="btn btn-dark btn-icon-sm">
                        <input type="file" onChange={onImport} ref={refImport} hidden/>
                        Импорт
                    </label>
                    <label className="btn btn-dark btn-icon-sm" style={{ cursor: 'pointer' }}>
                        <input type="file" onChange={onImportReceipes} ref={refImportReceipes} hidden/>
                        Импорт рецептов
                    </label>
                    {window.innerWidth > 1024 && 
                    <>
                    <button 
                    onClick={((e) => {
                        e.stopPropagation();
                        onOpenModalGroup();
                    })}
                    className="btn btn-success btn-icon-sm"
                    >
                        Добавить группу товаров
                    </button>
                    <button 
                    onClick={((e) => {
                        e.stopPropagation();
                        onOpenModalGood();
                    })}
                    className="btn btn-success btn-icon-sm"
                    >
                        Добавить товар
                    </button>
                    </>
                    }
                    <button onClick={onRefresh} className="btn btn-secondary btn-icon"><i className="la la-refresh"></i></button>
                </div>
            </div>
            </div>
        );
    };

    return (
        <div>
            <HeadMobileActionMenu actions={actionsMobile}/>
            { renderSubHeader() }
            <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
                <ErrorContainer field="goods" hasCloseButton={true}/>
                <ErrorContainer field="category" hasCloseButton={true}/>
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo goods">
                    <div className='kt-grid__item kt-portlet kt-todo__aside goods'>
                       <CategoryList/>
                    </div>
                    <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                        <button onClick={() => setType('goods')} className={`btn btn-sm ${type === 'goods' ? 'btn-primary' : 'btn-light'}`}> Товары </button>
                        <button onClick={() => setType('groups')} className={`btn btn-sm ${type === 'groups' ? 'btn-primary' : 'btn-light'}`}> Группы </button>
                        {type === 'groups' ? <GroupsList /> : <GoodsList/>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ListGoodPage;